import { Injectable }     from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot }    from '@angular/router';

import { Observable } from 'rxjs';
import { ActivityLaunch } from 'modules/shared-postlogin/components/activity-launch/activity-launch.component';


@Injectable()
export class SaveWarningGuard  {
    
    constructor(){
    }

    canDeactivate(activityLaunch: ActivityLaunch, 
        currentRoute: ActivatedRouteSnapshot, 
        currentState: RouterStateSnapshot, 
        nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
            return activityLaunch.canDeactivate() as Observable<boolean> | Promise<boolean> | boolean; 
        }      
}
